import { render, staticRenderFns } from "./buyer-deposit.vue?vue&type=template&id=3c5a5ad0&scoped=true"
import script from "./buyer-deposit.vue?vue&type=script&lang=js"
export * from "./buyer-deposit.vue?vue&type=script&lang=js"
import style0 from "./buyer-deposit.vue?vue&type=style&index=0&id=3c5a5ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a5ad0",
  null
  
)

export default component.exports